import { getBaseUrl } from "./common";
import Form from "./form";
//import $ from "jquery";
//import 'jquery-validation-unobtrusive';

export default class ChangePasswordForm {
    private form: HTMLFormElement;

    constructor(form: HTMLFormElement) {
        this.form = form;
    }

    processForm(event: Event): void {
        const url = `${getBaseUrl()}ChangePassword/Index`;
        const form = new Form(url, this.form, 
            () => this.onSuccess(), 
            (html: string) => {
                document.querySelector(
                    '[data-component="ChangePassword"]'
                ).innerHTML = html;

                const formToRefresh = document.querySelector('[data-component=ChangePassword] form');
                //$.validator.unobtrusive.parse(formToRefresh);
        });

        form.process(event);
    }

    private onSuccess(): void {
        this.displaySuccessMessage();
    }

    private displaySuccessMessage(): void {
        const successMessageElement = document.getElementById('success-message');
        const form = document.querySelector('[data-component=ChangePassword] form') as HTMLElement;

        successMessageElement.style.display = 'block';
        form.style.display = 'none';
    }
}
